import { UIConfig } from "./../../UIConfig";
import { NodeFlags } from "../Const";
import { Sprite } from "../display/Sprite";
import { Event } from "../events/Event";
import { Box } from "./Box";
import { Dialog } from "./Dialog";
import { Widget } from "../components/Widget";
import { Ease } from "../tween/Ease";
import { Handler } from "../utils/Handler";
import { Tween } from "../tween/Tween";
import { ILaya } from "../../ILaya";
export class DialogManager extends Sprite {
    constructor() {
        super();
        this.maskLayer = new Sprite();
        this.popupEffect = (dialog) => {
            if (dialog._effectTween != null)
                Tween.kill(dialog._effectTween);
            const tx = dialog.x;
            const ty = dialog.y;
            const tsx = dialog.scaleX;
            const tsy = dialog.scaleY;
            dialog.pos(Math.round(ILaya.stage.width * 0.5), Math.round(ILaya.stage.height * 0.5));
            dialog.scale(0, 0);
            dialog._effectTween = Tween.create(dialog)
                .duration(300)
                .ease(Ease.backOut)
                .to("x", tx)
                .to("y", ty)
                .to("scaleX", tsx)
                .to("scaleY", tsy)
                .then(() => {
                this.doOpen(dialog);
            });
        };
        this.closeEffect = (dialog) => {
            if (dialog._effectTween != null)
                Tween.kill(dialog._effectTween);
            const tx = dialog.x;
            const ty = dialog.y;
            const tsx = dialog.scaleX;
            const tsy = dialog.scaleY;
            dialog._effectTween = Tween.create(dialog)
                .duration(300)
                .ease(Ease.strongOut)
                .to("x", Math.round(ILaya.stage.width * 0.5))
                .to("y", Math.round(ILaya.stage.height * 0.5))
                .to("scaleX", 0)
                .to("scaleY", 0)
                .then(() => {
                dialog.pos(tx, ty);
                dialog.scale(tsx, tsy);
                this.doClose(dialog);
            });
        };
        this.popupEffectHandler = new Handler(this, this.popupEffect);
        this.closeEffectHandler = new Handler(this, this.closeEffect);
        this.mouseEnabled = true;
        this.mouseThrough = true;
        this.maskLayer.mouseEnabled = true;
        this.zOrder = 1000;
        ILaya.stage.addChild(this);
        ILaya.stage.on(Event.RESIZE, this, this._onResize);
        if (UIConfig.closeDialogOnSide)
            this.maskLayer.on("click", this, this._closeOnSide);
        this._onResize(null);
    }
    _closeOnSide() {
        if (this.numChildren <= 0)
            return;
        var dialog = this.getChildAt(this.numChildren - 1);
        if (dialog instanceof Dialog)
            dialog.close("side");
    }
    _onResize(e = null) {
        var width = ILaya.stage.width;
        var height = ILaya.stage.height;
        this.size(width, height);
        this.maskLayer.size(width, height);
        if (this.lockLayer)
            this.lockLayer.size(width, height);
        this.maskLayer.graphics.clear(true);
        this.maskLayer.graphics.drawRect(0, 0, width, height, UIConfig.popupBgColor);
        this.maskLayer.alpha = UIConfig.popupBgAlpha;
        this.event(Event.RESIZE);
        for (var i = this.numChildren - 1; i > -1; i--) {
            var item = this.getChildAt(i);
            if (item.isPopupCenter && !this._hasLayout(item))
                this._centerDialog(item);
        }
    }
    _hasLayout(item) {
        const w = item._widget;
        if (!w || w === Widget.EMPTY)
            return false;
        return w.left != null || w.right != null || w.top != null || w.bottom != null || w.centerX != null || w.centerY != null;
    }
    _centerDialog(dialog) {
        dialog.x = Math.round(((ILaya.stage.width - dialog.width) >> 1) + dialog.pivotX);
        dialog.y = Math.round(((ILaya.stage.height - dialog.height) >> 1) + dialog.pivotY);
    }
    _clearDialogEffect(dialog) {
        if (dialog._effectTween) {
            Tween.kill(dialog._effectTween);
            dialog._effectTween = null;
        }
    }
    _closeAll() {
        for (var i = this.numChildren - 1; i > -1; i--) {
            var item = this.getChildAt(i);
            if (item && item.close != null) {
                this.doClose(item);
            }
        }
    }
    _checkMask() {
        if (this._destroyed)
            return;
        this.maskLayer.removeSelf();
        for (var i = this.numChildren - 1; i > -1; i--) {
            var dialog = this.getChildAt(i);
            if (dialog && dialog.isModal) {
                this.addChildAt(this.maskLayer, i);
                return;
            }
        }
    }
    setLockView(value) {
        if (!this.lockLayer) {
            this.lockLayer = new Box();
            this.lockLayer.mouseEnabled = true;
            this.lockLayer.size(ILaya.stage.width, ILaya.stage.height);
        }
        this.lockLayer.removeChildren();
        if (value) {
            value.centerX = value.centerY = 0;
            this.lockLayer.addChild(value);
        }
    }
    open(dialog, closeOther = false, showEffect = false) {
        if (closeOther)
            this._closeAll();
        this._clearDialogEffect(dialog);
        if (dialog.isPopupCenter)
            this._centerDialog(dialog);
        this.addChild(dialog);
        if (dialog.isModal || this._getBit(NodeFlags.HAS_ZORDER))
            ILaya.timer.callLater(this, this._checkMask);
        if (showEffect && dialog.popupEffect != null)
            dialog.popupEffect.runWith(dialog);
        else
            this.doOpen(dialog);
        this.event(Event.OPEN);
    }
    doOpen(dialog) {
        dialog.onOpened(dialog._param);
    }
    lock(value) {
        if (this.lockLayer) {
            if (value)
                this.addChild(this.lockLayer);
            else
                this.lockLayer.removeSelf();
        }
    }
    close(dialog) {
        this._clearDialogEffect(dialog);
        if (dialog.isShowEffect && dialog.closeEffect != null)
            dialog.closeEffect.runWith([dialog]);
        else
            this.doClose(dialog);
        this.event(Event.CLOSE);
    }
    doClose(dialog) {
        dialog.removeSelf();
        dialog.isModal && this._checkMask();
        dialog.closeHandler && dialog.closeHandler.runWith(dialog.closeType);
        dialog.onClosed(dialog.closeType);
        if (dialog.autoDestroyAtClosed)
            dialog.destroy();
    }
    closeAll() {
        this._closeAll();
        this.event(Event.CLOSE);
    }
    getDialogsByGroup(group) {
        var arr = [];
        for (var i = this.numChildren - 1; i > -1; i--) {
            var item = this.getChildAt(i);
            if (item && item.group === group) {
                arr.push(item);
            }
        }
        return arr;
    }
    closeByGroup(group) {
        var arr = [];
        for (var i = this.numChildren - 1; i > -1; i--) {
            var item = this.getChildAt(i);
            if (item && item.group === group) {
                item.close();
                arr.push(item);
            }
        }
        return arr;
    }
}
